import { EnvironmentFilled, FacebookFilled, InstagramFilled, LinkedinFilled, MailFilled, PhoneFilled, YoutubeFilled } from "@ant-design/icons";
import { Col, Layout, Row, Typography } from "antd";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './App.css';
import { CheckoutPage } from "./components/CheckoutPage";
import { IndexPage } from "./components/IndexPage";
import { GoFarmCapture } from "./products/GoFarmCapture";
import { GoFarmPage } from "./products/GoFarmPage";
import { globalStore } from "./store/store";

const NotFound = () => (
  <div style={{ textAlign: "center" }}>
    <h1>404 - Not Found</h1>
    <p>The resource you're looking for was not found.</p>
  </div>
)


const router = createBrowserRouter([
  {
    path: "/",
    element: <IndexPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage store={globalStore} />,
  },
  {
    path: "/gofarm",
    element: <GoFarmPage store={globalStore} />,
  },
  {
    path: "/gofarm/registro",
    element: <GoFarmCapture store={globalStore} />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

function App() {
  return (
    <div className="app">
      <Layout.Header
        style={{
          background: "white",
          textAlign: "center",
        }}
      >
        <div style={{
          padding: "0px 50px 50px",
          width: 1150,
          margin: "auto",
          boxSizing: "border-box",
          position: "relative",
        }}>
          <Typography.Link href="/">
            <img
              src="/img/tecgraf-agro.png"
              style={{
                height: 64,
              }}
            />
          </Typography.Link>
        </div>

      </Layout.Header>

      <RouterProvider router={router} />

      <Layout.Footer
        style={{ background: "#374447", color: "#fff" }}
      >
        <div style={{ maxWidth: 1100, margin: "auto" }}>
          <Row gutter={30}>
            <Col sm={6}>
              <a href="http://www.tecgraf.com.br">
                <img
                  src="https://tecgraf.com.br/wp-content/uploads/2021/10/TECGRAF-AGRO1_p_black_bg.png"
                  style={{ width: "100%" }}
                />
              </a>
            </Col>
            <Col sm={6}>
              <div className="textwidget">
                <h3 className="logofont" style={{ color: "#eee" }}>Quem Somos?</h3>
                Somos uma empresa de tecnologia em computação gráfica focada em fornecer soluções para projetos agrícolas.
              </div>
            </Col>
            <Col sm={6}>
              <aside id="widget_kadence_contact-1" className="widget widget_kadence_contact">
                <h3>Onde Estamos?</h3>
                <div className="vcard">
                  <p className="vcard-address">
                    <EnvironmentFilled />
                    {" "}
                    Av, Aquidaban, 766, Sala 11<br />
                    Campinas SP 13026510
                  </p>
                  <p className="tel fixedtel">
                    <PhoneFilled />
                    {" "}
                    +55 19 2129.7177
                  </p>
                  <p>
                    <a className="email" href="mailto:tecgraf@tecgraf.com.br">
                      <MailFilled />
                      {" "}
                      tecgraf@tecgraf.com.br
                    </a>
                  </p>
                </div>
              </aside>
            </Col>
            <Col sm={6}>
              <div className="widget-1 widget-first footer-widget">
                <aside id="widget_kadence_social-1" className="widget widget_kadence_social">
                  <h3>Nossas Redes Sociais</h3>
                  <div className="virtue_social_widget">
                    <a href="https://www.facebook.com/AgroCADOficial">
                      <FacebookFilled />
                    </a>
                    <a href="https://www.instagram.com/agrocad360">
                      <InstagramFilled />
                    </a>
                    <a href="https://www.youtube.com/@agrocad360">
                      <YoutubeFilled />
                    </a>
                    <a href="https://www.linkedin.com/company/agrocad360">
                      <LinkedinFilled />
                    </a>
                  </div>
                </aside>
              </div>
            </Col>
          </Row>

          <div className="footercredits">
            <p>© 2024 TECGRAF AGRO</p>
          </div>
        </div>
      </Layout.Footer>
    </div>
  );
}

export default App;
